import {Logo} from "../Assets";
import {Link} from "react-router-dom";

import {HiOutlineMenuAlt2} from "react-icons/hi";
import MobileNav from "./mobile-nav";
import Navigations from "./Navigations";
import {motion} from "framer-motion";
import React, {useState} from "react";
import {useStateValue} from "../../context/StateProvider";
import {MdOutlineRestaurantMenu, MdShoppingBasket} from "react-icons/md";

const Header = () => {

    const [{showCart, cartItems, showContactForm}, dispatch] = useStateValue();
    const [isOpenMobileNav, setIsOpenMobileNav] = useState(false);
    const handleToggleCart = () => {
        dispatch({
            type: "TOGGLE_CART",
            showCart: !showCart,
        });
    };

    return (
        <header className="w-screen fixed z-50 bg-cardOverlay backdrop-blur-md md:p-3 md:px-4 lg:p-6 lg:px-16">
            {/*<div*/}
            {/*    className="m-3 p-2 border border-headingColor rounded-md inset-x-0 bottom-0 z-10 flex justify-center gap-x-8 gap-y-4 bg-cardOverlay ring-1 ring-gray-900/10 md:flex-row md:items-center lg:px-8">*/}
            {/*    <p className="text-base leading-6 text-headingColor">*/}
            {/*        Внимание! Сайт работает в тестовом формате. Заказ блюд временно не доступен.*/}
            {/*    </p>*/}
            {/*</div>*/}
            <div className="hidden md:flex w-full justify-between itesm-center">
                <Link to={"/"}>
                    <motion.div
                        whileHover={{scale: 1.1}}
                        className="flex items-center gap-2 cursor-pointer"
                    >
                        <img src={Logo} alt="Logo" className="md:w-16 lg:w-16 object-cover"/>
                    </motion.div>
                </Link>
                <Navigations/>
            </div>

            <motion.div
                className="flex md:hidden w-full p-0 items-center justify-between"
                initial={{opacity: 0, x: 200}}
                animate={{opacity: 1, x: 0}}
                exit={{opacity: 0, x: 200}}
            >
                {isOpenMobileNav ? (
                    <MobileNav isOpen={isOpenMobileNav} setIsOpen={setIsOpenMobileNav}/>
                ) : (
                    <div className="p-5 flex items-center justify-between w-full">
                        <motion.div
                            whileTap={{scale: 0.9}}
                            className=" flex items-center justify-center"
                            onClick={() => setIsOpenMobileNav(!isOpenMobileNav)}
                        >
                            <HiOutlineMenuAlt2 className="text-headingColor text-4xl"/>
                        </motion.div>
                        <Link to={"/"}>
                            <motion.div
                                whileHover={{scale: 1.1}}
                                className="flex items-center gap-2 cursor-pointer"
                            >
                                <img src={Logo} alt="Logo" className="w-14 object-cover"/>
                            </motion.div>
                        </Link>
                        <motion.div>
                            <motion.div
                                whileTap={{scale: 0.9}}
                                whileHover={{scale: 1.1}}
                                initial={{opacity: 0, x: 200}}
                                animate={{opacity: 1, x: 0}}
                                exit={{opacity: 0, x: 200}}
                                className="relative flex items-center justify-center text-textColor"
                                onClick={handleToggleCart}
                            >
                                <MdShoppingBasket className="text-4xl cursor-pointer"/>
                                {cartItems && (
                                    <div
                                        className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-cartNumBg flex items-center justify-center">
                                        <p className="text-sm text-white font-semibold">
                                            {cartItems.length}
                                        </p>
                                    </div>
                                )}
                            </motion.div>
                        </motion.div>
                    </div>
                )}
            </motion.div>
        </header>
    );
};

export default Header;
